import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { DASHBOARD_RESOURCES } from 'constant';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';
import { URL as DowntimeManagementUrl, FINANCE_RESOURCES } from '../helper';
import { URL, COMPONENT, DOWNTIMEMANAGEMENT_RESOURCES, GET_ACTION } from './downtimeManagementHelper';
import DowntimeManagementList from './DowntimeManagementList';

const DowntimeManagementDashboardHome: React.FC = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={DASHBOARD_RESOURCES.finance}
					configResourceName={FINANCE_RESOURCES.downtimeManagement}
					configActionName='getAllDowntimeManagementCards'
					path={DowntimeManagementUrl.downtimeManagement}
					component={DowntimeManagementList}
				/>
				{_map(_values(DOWNTIMEMANAGEMENT_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={FINANCE_RESOURCES.downtimeManagement}
						configResourceName={subEntity}
						configActionName={GET_ACTION[subEntity]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DowntimeManagementUrl.downtimeManagement} />
			</Switch>
		</>
	);
};

export default DowntimeManagementDashboardHome;
